import { Component, inject } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { CustomerInfo } from '../../../payplus.service';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-billing-details',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    FormsModule,
    FormsModule,
    MatDialogModule,
    MatButtonModule

  ],
  templateUrl: './billing-details.component.html',
  styleUrl: './billing-details.component.scss'
})
export class BillingDetailsComponent {

  name = new FormControl('', [Validators.required])
  phoneNumber = new FormControl('', [Validators.required, Validators.maxLength(10)])
  email = new FormControl('', [Validators.required])
  passKey: string = '';
  readonly dialogRef = inject(MatDialogRef<BillingDetailsComponent>);

  readonly data = inject<CustomerInfo>(MAT_DIALOG_DATA);
  qty=1;


  constructor() {


  }
  confirmOrder() {
    const ph = this.phoneNumber.value!.charAt(0) === '0' ? this.phoneNumber.value?.substring(1, this.phoneNumber.value.length) : this.phoneNumber.value
    const kyc = {
      firstname: this.name.value?.split(' ')[0],
      lastname: this.name.value?.split(' ').length! > 1 ? this.name.value?.split(' ')[1] : ' ',
      phoneNumber: ph!,
      email: this.email.value!,
      dialCode: '+94',
      qty:this.qty

    }
    this.dialogRef.close(kyc)

  }

  formValid(): boolean {
    return this.name.value!.length>0 && this.phoneNumber.value!.length>0 && this.email.value!.length>0
  }


  reduce() {
    if (this.qty !== 1) {
      this.qty--;
    }
  }
  increase() {
     if (this.qty !== 10) {
    this.qty++;
     }
  }


}
